export const PAGE_TAB_TITLE_PRODUCT = {
  cbplus: 'Credit Builder Plus',
  crypto: 'Crypto',
  instacash: 'Instacash',
  investment: 'Investment',
  roarmoney: 'RoarMoney',
  liteCoreOnboarding: 'Onboarding',
}
